import { makeAutoObservable } from 'mobx'
import { differenceInDays, subDays } from 'date-fns'

import { IBaby, Nullable } from 'types'
import { notification } from 'services'
import { ChartApi } from 'api'
import { DateParams } from 'api/ChartApi'

import { generateDateParams, transformDurationEvents, transformOneTimeEvents } from './utils'
import { ChartEvents } from './types'

export default class ChartStore {
  loading = false
  events: Nullable<ChartEvents> = null
  baby: Nullable<IBaby> = null

  loadingMore = false
  today = new Date()
  dateParams: DateParams

  constructor() {
    this.dateParams = generateDateParams(this.today)

    makeAutoObservable(this, undefined, { autoBind: true })
  }

  get daysToShow() {
    return differenceInDays(this.today, this.dateParams.startTime) + 1
  }

  setBaby = (baby: IBaby) => {
    this.baby = baby
  };

  *loadEvents(isPremium: boolean) {
    try {
      if (this.baby?.id) {
        this.loading = true

        const premiumDateParams = isPremium ? this.dateParams : generateDateParams(this.today, 2)

        const { data } = yield ChartApi.getEvents(this.baby.id, premiumDateParams)
        const events = data.data

        this.events = {
          longTerm: transformDurationEvents(events),
          oneTime: transformOneTimeEvents(events),
        }
      }
    } catch {
      notification.error('Ошибка загрузки событий')
    } finally {
      this.loading = false
    }
  }

  *loadMoreEvents() {
    if (this.loadingMore) {
      return
    }

    this.loadingMore = true

    try {
      if (this.baby?.id) {
        const endTime = subDays(this.dateParams.startTime, 1)
        const newDateParams = generateDateParams(endTime)

        const { data } = yield ChartApi.getEvents(this.baby.id, newDateParams)
        const events = data.data

        this.dateParams = newDateParams

        this.events = {
          longTerm: {
            ...this.events?.longTerm,
            ...transformDurationEvents(events),
          },
          oneTime: [...(this.events?.oneTime || []), ...transformOneTimeEvents(events)],
        }
      }
    } catch {
      notification.error('Ошибка загрузки событий')
    } finally {
      this.loadingMore = false
    }
  }
}
